module.exports = parcelRequire.resolve("bA5u8");